var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',[_vm._l((_vm.tabs),function(item,i){return _c('v-col',{key:i,attrs:{"cols":"auto"}},[_c('v-btn',{attrs:{"text":!_vm.tab_selected(item),"to":("/tasks/" + (item.id))}},[_vm._v(" "+_vm._s(item.name)+" ")])],1)}),_c('v-spacer')],2)}
var staticRenderFns = []

export { render, staticRenderFns }